<template>
  <div 
    :class="{
      'amount-input__left': !currencyOnRight,
      'amount-input__right': currencyOnRight
    }"
    class="amount-input"
  >
    <span>{{ currencySymbol }}</span> 
    <input
     class="w-full"
     v-model="currentValue"
      type="number"
      placeholder="Enter other amount"
      step=".01"
      @input="onInput($event)"
    >
  </div>
</template>

<script>
import currencies from '@/helpers/currencies'

export default {
  props: {
    currencyCode: {
      type: String,
      default: 'USD'
    },

    currencyOnRight: {
      type: Boolean,
      default: false
    },

    value: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      currentValue: ''
    }
  },

  computed: {
    currencySymbol() {
      return currencies[this.currencyCode].symbol
    }
  },

  watch: {
    value() {
      this.currentValue = this.value
    }
  },

  mounted() {
    this.currentValue = this.value
  },

  methods: {
    countDecimals(value) {
      if (Math.floor(value) === parseFloat(value) || value == '') {
        return 0
      }

      let split = value.toString().split('.')
      if (split.length < 2) {
        split = value.toString().split(',')
      }
      return split[1].length || 0
    },

    getFormattedValue(value) {
      if (Math.floor(value) === parseFloat(value) || value == '') {
        return value
      }

      let split = value.toString().split('.')
      if (split.length < 2) {
        split = value.toString().split(',')
      }
      return `${split[0]}.${split[1].substr(0, 2)}`
    },

    onInput(event) {
      console.log(this.countDecimals(event.target.value))
      if (this.countDecimals(event.target.value) < 3) {
        this.$emit('input', event.target.value)
      } else {
        this.currentValue = this.getFormattedValue(event.target.value)
        this.$emit('input', this.getFormattedValue(event.target.value))
      }
    }
  }
}
</script>
